import { adminViewTranslations } from './admin/adminView.translations.en.ts';
import { loginViewTranslation } from './login/loginView.translation.en.ts';
import { errorsTranslations } from './process/errors/errors.translation.en.ts';
import { processViewTranslations } from './process/processView.translations.en.ts';
import { serviceUnavailableTranslation } from './serviceUnavailable/serviceUnavailable.translation.en.ts';
import { validationTranslation } from './validation/validation.translation.en.ts';
import type { ViewsTranslations } from './views.translations.pl.ts';

export const viewsTranslations: ViewsTranslations = {
  admin: adminViewTranslations,
  login: loginViewTranslation,
  process: processViewTranslations,
  validation: validationTranslation,
  errors: errorsTranslations,
  serviceUnavailable: serviceUnavailableTranslation,
};
